/**
 * Kanaal voor live "reviewrecord gewijzigd"-seintjes van de eigen lijnteksten. Zelfde neutrale
 * patroon als `chart-change-signals`: de platformlaag (`PlatformInstanceListener`) levert de
 * berichten aan, de reviewservice in de Human Design-laag luistert. Zonder luisteraar zijn de
 * meldingen no-ops. Het eigen seintje (zelfde `CLIENT_INSTANCE_ID`) wordt hier al genegeerd: die
 * stand staat al lokaal.
 */
import { CLIENT_INSTANCE_ID } from '@common/chart-change-signals/chart-change-signals';

/** Ruwe vorm van het reviewrecord in het bericht (System.Text.Json, camelCase). */
export interface LineTextReviewMessageRecord {
  readonly gate?: number | null;
  readonly line?: number | null;
  readonly lang?: string | null;
  readonly field?: string | null;
  readonly text?: string | null;
  readonly approved?: boolean | null;
  readonly updatedByUserAccountId?: string | null;
  readonly updatedByDisplayName?: string | null;
  readonly updatedOn?: string | null;
}

/** Ruwe vorm van het `LineTextReviewChanged`-bericht. */
export interface LineTextReviewChangedMessage {
  readonly review?: LineTextReviewMessageRecord | null;
  readonly originClientId?: string | null;
}

export type LineTextReviewChangeListener = (review: LineTextReviewMessageRecord) => void;

let listener: LineTextReviewChangeListener | undefined;

/** Registreert (of wist, met `undefined`) de luisteraar. */
export function setLineTextReviewChangeListener(value: LineTextReviewChangeListener | undefined): void {
  listener = value;
}

/** Aangeroepen door de hub-listener per ontvangen `LineTextReviewChanged`-bericht. */
export function notifyRemoteLineTextReviewChange(message: LineTextReviewChangedMessage | null | undefined): void {
  const review = message?.review;
  if (!review || message?.originClientId === CLIENT_INSTANCE_ID) {
    return;
  }
  if (typeof review.gate !== 'number' || typeof review.line !== 'number' || !review.lang || !review.field) {
    return;
  }
  listener?.(review);
}
